import script from "./MInfoAndHelp.vue?vue&type=script&setup=true&lang=ts"
export * from "./MInfoAndHelp.vue?vue&type=script&setup=true&lang=ts"

import "./MInfoAndHelp.vue?vue&type=style&index=0&id=43b1e96a&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43b1e96a"]])

export default __exports__